import { Helmet } from "react-helmet-async";

function SEO({ title, description, keywords, image, url }) {
  return (
    <Helmet>
      <title>
        {title || "TechSharthi Academy | Online Certification Courses"}
      </title>
      <meta
        name="description"
        content={
          description ||
          "Learn AI, Cloud Computing, Full Stack Development, Data Science, and more with TechSharthi Academy's expert-led courses."
        }
      />
      <meta
        name="keywords"
        content={
          keywords ||
          "TechSharthi, online courses, certification, AI, cloud computing, full stack development, data science,AWS with Devops,MainFrame Modernization With Cloud Computing,Data Analytics with Power BI,AWS Cloud Support Associate Course,AWS Data Engineer,Linux Mastery Course,Master Soft Skills"
        }
      />
      <meta name="robots" content="index, follow" />

      {/* Open Graph Tags */}
      <meta
        property="og:title"
        content={title || "TechSharthi Academy | Online Certification Courses"}
      />
      <meta
        property="og:description"
        content={
          description ||
          "Learn AI, Cloud Computing, Full Stack Development, Data Science, and more with TechSharthi Academy's expert-led courses."
        }
      />
      <meta
        property="og:image"
        content={image || "https://techsharthiacademy.com/Logo.png"}
      />
      <meta
        property="og:url"
        content={url || "https://techsharthiacademy.com/"}
      />
      <meta property="og:type" content="website" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content={title || "TechSharthi Academy | Online Certification Courses"}
      />
      <meta
        name="twitter:description"
        content={
          description ||
          "Learn AI, Cloud Computing, Full Stack Development, Data Science, and more with TechSharthi Academy's expert-led courses."
        }
      />
      <meta
        name="twitter:image"
        content={image || "https://techsharthiacademy.com/Logo.png"}
      />

      {/* Canonical URL */}
      <link rel="canonical" href={url || "https://techsharthiacademy.com/"} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "EducationalOrganization",
          name: "TechSharthi Academy",
          url: "https://www.techsharthiacademy.com/",
          logo: "https://techsharthiacademy.com/Logo.png",
          sameAs: [
            "https://www.instagram.com/techsharthiacademy_official/",
            "https://www.linkedin.com/company/techsharthi-academy/",
            "https://x.com/techsharthi",
            "https://youtube.com/@techsharthiacademy?si=Eh1aEx_9-HjiN9pi",
          ],
          description:
            "TechSharthi Academy offers online certification courses in AI, Cloud Computing, Full Stack Development, Data Science, and More.",
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "+91-9835732960",
            contactType: "customer support",
          },
        })}
      </script>
    </Helmet>
  );
}

export default SEO;
